import { mapGetters } from 'vuex';
import moment from 'moment';
import { SOURCE_CONTROLLER, SOURCE_MANUAL, SOURCE_IOT } from '@/aquassist-shared/constants/types/flowMeters';


export default {
    computed: {
        ...mapGetters([
            'team',
        ]),
    },
    methods: {
        async createFlowMeter(requestPayload, node) {
            const site = this.siteId || this.site.id;
            const payloadClone = { ...requestPayload };
            // we only create the meter if it is of type manual or controller
            if (payloadClone.dataSource === SOURCE_MANUAL || payloadClone.dataSource === SOURCE_CONTROLLER) {
                const payload = {
                    team: this.team.id,
                    site,
                    node,
                    name: payloadClone.name || payloadClone.probe,
                    volumePerPulse: 0,
                    resetAt: 0,
                    revolutions: 0,
                    active: true,
                    totalPulses: 0,
                    totalVolume: 0,
                    lastReadingDate: moment()
                        .toISOString(),
                    ...payloadClone,
                };
                const { data } = await this.$rq.addFlowMeter(site, [payload]);
                payloadClone.flowMeter = data[0].id;
            }

            if (payloadClone.dataSource === SOURCE_IOT) {
                const { data } = await this.$rq.getFlowMeter(site, requestPayload.flowMeter);
                await this.$rq.updateFlowMeter(site, payloadClone.flowMeter, {
                    ...data,
                    type: requestPayload.type,
                    dataSource: payloadClone.dataSource,
                });
            }
            return payloadClone;
        },
    },
};
